import React from "react";
import { styled } from "@mui/material/styles";
import { Link } from "@mui/material";

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
}));

const SkipButton = ({ onClickFn, ...props }) => {
  return (
    <StyledLink component="button" variant="body2" onClick={onClickFn} size="small" {...props}>
      Skip
    </StyledLink>
  );
};

export default SkipButton;
